import { render, staticRenderFns } from "./RequiredKauLogin.vue?vue&type=template&id=6a5fd3b3&scoped=true"
import script from "./RequiredKauLogin.vue?vue&type=script&lang=js"
export * from "./RequiredKauLogin.vue?vue&type=script&lang=js"
import style0 from "./RequiredKauLogin.vue?vue&type=style&index=0&id=6a5fd3b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5fd3b3",
  null
  
)

export default component.exports